import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { OpenDirectoryButton } from '../../common/OpenDirectoryButton';
import { path, type UiPathName } from '../../paths';
import { useNavigateTo } from '../../paths/useNavigateTo';
import { DataObjectDetails } from '../data-objects/DataObjectDetails';
import { INPUT_DATA_OBJECT_ROUTES } from './InputDataObjects';
import { DataObjectView, loadViewState } from '@atlas-frontend/sdk';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './InputDataObjectDetails.translations.json';

const { addTranslations, useTranslation } = i18nNsFactory(
  'input-data-object-details',
);
addTranslations(translations);

export const InputDataObjectDetails = () => {
  const { id } = useParams() as { id: string | number };
  const { t } = useTranslation();

  const navigateToDetails = useNavigateTo(path.inputDataObjectView, { id });
  const navigateToEdit = useNavigateTo(path.inputDataObjectEdit, { id });
  const navigateToClone = useNavigateTo(path.inputDataObjectClone, { id });
  const navigateToDirectory = useNavigateTo(path.inputDataObjectDirectory);

  const openDirectoryButtonOptions = useMemo(() => {
    const options = [];

    options.push({
      id: 'inputDataObjectDirectory',
      path: path.inputDataObjectDirectory,
      label: t('button.inputDataObjectDirectory'),
    });

    const viewState = loadViewState<UiPathName>('inputDataDetails');
    if (viewState) {
      options.push({
        id: 'inputDataDetails',
        path: path.inputDataDetails,
        params: {
          descriptionId: viewState.descriptionId,
          date: viewState.date,
          subject: viewState.subject,
          groupId: viewState.groupId,
        },
        label: t('button.inputDataDetails'),
      });
    }

    return options;
  }, [t]);

  return (
    <DataObjectDetails
      routes={INPUT_DATA_OBJECT_ROUTES}
      view={DataObjectView.IN}
      navigateToDetails={navigateToDetails}
      navigateToEdit={navigateToEdit}
      navigateToClone={navigateToClone}
      navigateToDirectory={navigateToDirectory}
      actions={<OpenDirectoryButton options={openDirectoryButtonOptions} />}
    />
  );
};
